module.exports = __webpack_public_path__ + "static/media/loading.41aa0b0f.gif";